import { FC, useState, useEffect } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Button from "components/particles/primary-button";

import { Container, StyledReactModal } from "./style";
import { useRetailerOnboarding } from "./useHook";

interface RetailerOnboardingModalProps {
    isOpen: boolean;
    action: "onboard" | "block" | null;
    onClose: () => void;
    retailerId: string;
    onSuccess?: () => void;
}

const RetailerOnboardingModal: FC<RetailerOnboardingModalProps> = ({
    isOpen,
    action,
    onClose,
    retailerId,
    onSuccess,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const { toggleOnBoardingStatus } = useRetailerOnboarding();

    const handleYesClick = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await toggleOnBoardingStatus(retailerId);
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error("Error toggling onboarding status:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const modalTitle = action === "onboard"
        ? "Onboard Retailer"
        : "Block Retailer";

    const modalMessage = action === "onboard"
        ? "Are you sure you want to onboard this retailer?"
        : "Are you sure you want to block this retailer?";

    return (
        <StyledReactModal 
            isOpen={isOpen} 
            contentLabel="Retailer Onboarding Modal"
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                content: {
                    position: 'relative',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    transform: 'none',
                    margin: 'auto',
                    maxWidth: '68.5rem',
                    width: '90%',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    borderRadius: '2rem',
                    border: 'none',
                    padding: 0,
                    zIndex: 1000
                }
            }}
        >
            <Container>
                <div className="close-button" onClick={onClose}>
                    <img src={close} alt="Close button" />
                </div>
                <div className="model-container">
                    <div
                        style={{ width: "100%", textAlign: "center", marginTop: "4rem", flexGrow: 1,flexDirection: "column" }}
                    >
                        <h1>{modalTitle}</h1>
                        <p>
                            {modalMessage}
                        </p>
                    </div>
                    <div>
                        <div className="add-button">
                            <Button
                                title={isLoading ? "Processing..." : "Yes"}
                                width="25rem"
                                backgroundcolor="var(--primary)"
                                fill="true"
                                onclick={isLoading ? undefined : handleYesClick}
                            />
                        </div>
                        <div className="add-button">
                            <Button
                                title="No"
                                width="25rem"
                                backgroundcolor="var(--reset-button)"
                                fill="true"
                                onclick={isLoading ? undefined : onClose}
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </StyledReactModal>
    );
};

export default RetailerOnboardingModal;